import { useEffect, useRef } from "react";
import { ParentButton, SubText, Paper } from "@base-ui";
import Image from "@cms/components/ui/Image";
import { closePopup } from "utils/events";
import { useLockedFocusArea } from "hooks";
import graph from "@cms/assets/components/graph.png";
import article from "@cms/assets/components/article.png";
import video from "@cms/assets/components/video.png";
import link from "@cms/assets/components/links.png";
import paragraph from "@cms/assets/components/paragraph.png";
import quote from "@cms/assets/components/quote.png";
import iconQuote from "@cms/assets/components/iconQuote.png";
import img from "@cms/assets/components/img.png";
import icon from "@cms/assets/components/icon.png";
import highlights from "@cms/assets/components/highlights.png";
import measureEvents from "@cms/assets/components/measureEvents.png";
import measureSpotlight from "@cms/assets/components/measureSpotlight.png";
import linkCard from "@cms/assets/components/linkCard.png";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SelectComponentTypePopup(_ref) {
  var selectableModules = _ref.selectableModules,
    callback = _ref.callback;
  var containerRef = useRef();
  var firstRef = useRef();
  var lastRef = useRef();
  useLockedFocusArea(containerRef, firstRef, lastRef);
  useEffect(function () {
    document.getElementById("select-module-".concat(selectableModules[0])).focus();
  }, [selectableModules]);
  var modules = {
    GRAPH: {
      label: "Graf",
      alt: "Bild föreställande graf",
      src: graph
    },
    PARAGRAPH: {
      label: "Stycke",
      alt: "Bild föreställande paragraf",
      src: paragraph
    },
    QUOTE: {
      label: "Citat",
      alt: "Bild föreställande citat",
      src: quote
    },
    ICON_QUOTE: {
      label: "Ikon + Citat",
      alt: "Bild föreställande ikon + citat",
      src: iconQuote
    },
    IMAGE: {
      label: "Bild",
      alt: "Bild föreställande bild",
      src: img
    },
    ICON: {
      label: "Ikon",
      alt: "Bild föreställande ikon",
      src: icon
    },
    ARTICLE: {
      label: "Artikel",
      alt: "Bild föreställande en artikel",
      src: article
    },
    VIDEO: {
      label: "Video",
      alt: "Bild föreställande video",
      src: video
    },
    LINKS: {
      label: "Länk",
      alt: "Bild föreställande länk",
      src: link
    },
    LINK_CARD: {
      label: "Länk kort",
      alt: "Bild föreställande länk kort",
      src: linkCard
    },
    HIGHLIGHTS: {
      label: "Puffar",
      alt: "Bild föreställande länk",
      src: highlights
    },
    MEASURE_EVENTS: {
      label: "Nyhetsflöde",
      alt: "Bild föreställande ett nyhetsflöde",
      src: measureEvents
    },
    MEASURE_SPOTLIGHTS: {
      label: "Kort",
      alt: "Bild föreställande kort",
      src: measureSpotlight
    }
  };
  var handleSelectModule = function handleSelectModule(type) {
    closePopup();
    callback({
      type: type
    });
  };
  var modulesMarkup = selectableModules.filter(function (x) {
    return x !== "NONE";
  }).map(function (module, idx) {
    var _modules$module = modules[module],
      label = _modules$module.label,
      src = _modules$module.src,
      alt = _modules$module.alt;
    var moduleRef = idx === 0 ? firstRef : idx === selectableModules.length - 1 ? lastRef : undefined;
    return /*#__PURE__*/_jsxs(ParentButton, {
      id: "select-module-".concat(module),
      ref: moduleRef,
      "aria-label": "V\xE4lj ".concat(label),
      onClick: function onClick() {
        return handleSelectModule(module);
      },
      flexDirection: "column",
      alignItems: "center",
      p: "5px 10px",
      m: "5px",
      children: [/*#__PURE__*/_jsx(Image, {
        id: src,
        src: src,
        alt: alt,
        height: "70px",
        width: "auto",
        mb: "5px",
        objectFit: "contain"
      }), /*#__PURE__*/_jsx(SubText, {
        as: "label",
        htmlFor: "select-module-".concat(module),
        children: label
      })]
    }, module);
  });
  return /*#__PURE__*/_jsx(Paper.Row, {
    p: "md",
    ref: containerRef,
    maxWidth: "585px",
    flexWrap: "wrap",
    children: modulesMarkup
  });
}